<template>
    <div class="d-flex align-items-center">
        <b class="item-price">
            $ {{ item.empresa_id !== 0 ? numberFormat(item.precio) : numberFormat(item.precio_final_con_imp) }}
        </b>

        <span class="ml-auto" v-if="item.empresa_id != 0">
            <div >
                <b-icon v-if="checkOptionExistenseAndItemExistence(item)"
                    icon="cart-plus"
                    class="mr-4 icon-scale "
                    v-b-tooltip.hover
                    title="Agregar"
                    :style="cssVars"
                    @click.prevent="$parent.$emit('add-item', item)"
                    scale="2"
                ></b-icon>
                <b-icon v-else
                    icon="dash-circle"
                    class="mr-4"
                    v-b-tooltip.hover
                    title="Producto Agotado"
                    variant="danger"
                    :style="cssVars"
                    scale="2"
                ></b-icon>
                <b-icon
                    icon="info-circle-fill" 
                    class="icon-info" 
                    v-b-tooltip.hover 
                    title="Más información" 
                    :style="cssVars" scale="2" 
                    @click.prevent="$parent.$emit('item-info', item)">
                </b-icon>
            </div>
        </span>
        <span class="ml-auto" v-else>
            <div class="ml-auto">
                <strong class="mr-3" v-if="item.precio_personalizado == 2" style="font-size: 20px;">DC</strong>
                <b-icon v-if="checkItemExistenceAndPrice(item)"
                    icon="cart-plus"
                    class="mr-4 icon-scale "
                    v-b-tooltip.hover
                    title="Agregar"
                    :style="cssVars"
                    @click.prevent="$parent.$emit('add-item', item)"
                    scale="2"
                ></b-icon>
                <b-icon v-else
                    icon="dash-circle"
                    class="mr-4"
                    v-b-tooltip.hover
                    title="Producto Agotado"
                    variant="danger"
                    :style="cssVars"
                    scale="2"
                ></b-icon>
                <b-icon
                    icon="info-circle-fill" 
                    class="icon-info" 
                    v-b-tooltip.hover 
                    title="Más información" 
                    :style="cssVars" scale="2" 
                    @click.prevent="$parent.$emit('item-info', item)">
                </b-icon>
            </div>
        </span>
    </div>
</template>

<script>
import { mapState} from 'vuex'
export default {
    name: "CardFooter",
    props: {
        item: {
            type: Object
        }       
    },
    computed: {
        ...mapState('configuration', ['background', 'opcionExistencia', 'DELIVERY_TYPE']),
        cssVars() {
            return {
                '--border-bottom': this.background
            };
        },
    },
    methods: {
        checkItemExistenceAndPrice(item) {
            return (
                item.quantity > 0 && item.precio_final_con_imp > 0
            );
        },
        checkOptionExistenseAndItemExistence(item){
            return (
                (this.opcionExistencia === 1 && item.existencia > 0)
            );
        }
    }

};

</script>
<style scoped>

.icon-scale{
    transition: transform .4s;
    cursor: pointer;
}
.icon-scale:hover{
    transform: scale(1.2);
    color: var(--border-bottom);
}
.icon-info{
    color: var(--border-bottom);
    cursor: pointer;
}

.d-flex{
    min-height: 32px;
}



</style>